import React from 'react';
import { matchDisplayName } from '../../utils';
import styles from './styles.scss';
export var FormRow = function FormRow(props) {
  return React.createElement("div", {
    className: styles.formRow
  }, React.Children.map(props.children, function (childRef) {
    if (matchDisplayName(childRef, 'FormItem')) {
      return React.cloneElement(childRef, {
        className: styles.inputGroupFormItem
      });
    } else {
      return childRef;
    }
  }));
};